import styled from 'styled-components';
import { BodyRegularS } from '../../../../../../styles/globals';
import { ITheme, IThemeProvider } from '../../../../../../styles/theme';
import DropdownIcon from '@/assets/icons/chevron-left.svg?react';
import ExpandArrowClose from '@/assets/icons/closeAllAccordion.svg?react';
import ExpandArrowOpen from '@/assets/icons/openAllAccordion.svg?react';

interface RowProps {
  theme: ITheme;
  isDropMenuActive: boolean;
}

export const Row = styled.tr<RowProps>`
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 8fr;
  height: 52px;
  margin-top: 8px;
  border-radius: ${({ isDropMenuActive }) => (isDropMenuActive ? '8px 8px 0 0' : '8px')};
  ${({ theme, isDropMenuActive }: RowProps) => `
    background: ${theme.colors.neutral.primary[0]};
    border-bottom: ${isDropMenuActive ? 'none' : `1px solid ${theme.colors.neutral.primary[30]}`};
  `}
`;

export const ArrowIcon = styled(DropdownIcon)<{ isDropMenuActive: boolean }>`
  transform: ${({ isDropMenuActive }) => (isDropMenuActive ? 'rotate(90deg)' : 'rotate(0deg)')};
  cursor: pointer;
`;

export const ExpandArrowOpenIcon = styled(ExpandArrowOpen)`
  cursor: pointer;
`;
export const ExpandArrowCloseIcon = styled(ExpandArrowClose)`
  cursor: pointer;
`;

export const Cell = styled.td<IThemeProvider>`
  font-weight: 600;
  letter-spacing: 0.07px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  &:first-child {
    justify-content: left;
    margin-left: 2rem;
  }
  &:nth-child(2) {
    font-size: 18px;
    ${({ theme }) => `
    color: ${theme.colors.neutral.primary[90]};
  `}
  }
  &:last-child {
    margin-left: 1rem;
  }
`;

export const LabelText = styled(BodyRegularS)`
  font-size: 17px;
  line-height: 19px;
  font-weight: 500;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[90]};
  `}
`;
